import { render, staticRenderFns } from "./ModuleCatalyst.vue?vue&type=template&id=2e216d42&scoped=true&lang=pug&"
import script from "./ModuleCatalyst.vue?vue&type=script&lang=js&"
export * from "./ModuleCatalyst.vue?vue&type=script&lang=js&"
import style0 from "./ModuleCatalyst.vue?vue&type=style&index=0&id=2e216d42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e216d42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VImg})
